/**
 * Role: Trade-in modal form controller
 * Handles open/close behavior and dynamic card binding via MutationObserver
 */
'use strict';

const CLOSE_BTN_HTML = `<span class="svg-wrapper close-btn">
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L2 12M12 12L2 2" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</span>`;

const doc = document.documentElement;

const MODAL_SELECTOR = '.modal-wrapper[data-role="trade-in-modal-form-wrapper"]';
const CONTAINER_SELECTOR = '.custom-section-content';
const CARD_SELECTOR = 'product-card.product-card';
const PRODUCT_DETAILS_SELECTOR = '.product-details';
const TRADE_BTN_ROLE = 'button[data-role="trade-in-form"]';
const HIDDEN_CLASS = 'at-hidden';
const OVERFLOW_CLASS = 'no-scroll';

const modal = document.querySelector(MODAL_SELECTOR);
if (!modal) throw new Error(`[trade-in] Modal not found: ${MODAL_SELECTOR}`);

const container = modal.querySelector(CONTAINER_SELECTOR);
if (!container) throw new Error(`[trade-in] Modal not found: ${CONTAINER_SELECTOR}`);

container?.insertAdjacentHTML('afterbegin', CLOSE_BTN_HTML);
const closeBtn = modal.querySelector('.close-btn');
if (!closeBtn) throw new Error(`closeBtn not found`);

const hideModal = () => {
  modal.classList.add(HIDDEN_CLASS);
  doc.classList.remove(OVERFLOW_CLASS);
}

const showModal = () => {
  modal.classList.remove(HIDDEN_CLASS);
  doc.classList.add(OVERFLOW_CLASS);
}

closeBtn?.addEventListener('click', hideModal);

window.addEventListener('click', ({ target }) => {
  if (target === modal) hideModal();
});

let activeProductUrl = null;

const updateProductUrlInput = () => {
  if (!activeProductUrl) return false;

  const host = document.querySelector("#app-embed");
  if (!host || !host.shadowRoot) return false;

  const productUrlInput = host.shadowRoot.querySelector('form input[data-testid="field-custom#product_url"]');
  
  if (productUrlInput) {
    productUrlInput.value = 'https://' + window.location.hostname + activeProductUrl;

    productUrlInput.dispatchEvent(new Event('input', { bubbles: true }));
    productUrlInput.dispatchEvent(new Event('change', { bubbles: true }));
    
    console.log('URL passed to input successfully:', activeProductUrl);
    return true;
  }
  
  return false;
};

const applyEmbedFormScript = () => {
  const host = document.querySelector("#app-embed");
  if (!host || !host.shadowRoot) return false;

  const form = host.shadowRoot.querySelector('form');
  if (!form) return false;

  updateProductUrlInput();

  return true;
};

const tradeInFormObserver = new MutationObserver((mutations, obs) => {
  if (applyEmbedFormScript()) {
    obs.disconnect();
  }
});

tradeInFormObserver.observe(document.body, {
  childList: true,
  subtree: true
});

function bindTradeInButtons(root = document) {
  root.querySelectorAll?.(`${CARD_SELECTOR} ${TRADE_BTN_ROLE}, ${PRODUCT_DETAILS_SELECTOR} ${TRADE_BTN_ROLE}`)
    .forEach(btn => {
      if (btn.dataset.tradeInBound) return;
      btn.dataset.tradeInBound = '1';
      
      btn.addEventListener('click', (e) => {
        const component = btn.closest('product-form-component');
        const detailsComponent = btn.closest('.btn-container')?.querySelector('product-form-component');
        
        const source = component ?? detailsComponent;
        if (source) {
          activeProductUrl = source.getAttribute('data-product-url');
          console.log('URL received when clicking:', activeProductUrl);
        }

        if (!component && !detailsComponent) {
          console.error('Element product-form-component not found');
        }

        if (component && detailsComponent) {
          console.error('Error mixing product-form-component');
        }

        updateProductUrlInput();
        
        showModal();
      });
    });
}

function initObserver() {
  bindTradeInButtons();

  new MutationObserver(mutations => {
    for (const { addedNodes } of mutations) {
      for (const node of addedNodes) {
        if (node.nodeType !== 1) continue;
        bindTradeInButtons(
          node.matches(CARD_SELECTOR) ? node.parentElement : node
        );
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initObserver);
} else {
  initObserver();
}

document.addEventListener('shopify:section:load', bindTradeInButtons);